import React from 'react';
import './Link.less';

export const Link = ({url, children}) => {
	return <a
		className="link"
		href={url}
		target="_blank"
		onClick={e => e.stopPropagation()}
	>
		{children}
	</a>
}
